import { render, staticRenderFns } from "./IncidentsWidget.vue?vue&type=template&id=5237fcf5&scoped=true&"
import script from "./IncidentsWidget.vue?vue&type=script&lang=js&"
export * from "./IncidentsWidget.vue?vue&type=script&lang=js&"
import style0 from "./IncidentsWidget.vue?vue&type=style&index=0&id=5237fcf5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5237fcf5",
  null
  
)

export default component.exports